<template>
  <div class="row user">
    <div class="col-md-3">
      <div class="tile p-0">
        <ul class="nav flex-column nav-tabs user-tabs">
          <li class="nav-item"><a class="nav-link active" href="#user-settings" data-bs-toggle="tab">ข้อมูลส่วนตัว</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-9">
      <div class="tab-content">
        <div class="tab-pane active" id="user-settings">
          <div class="tile user-settings">
            <h4 class="line-head d-flex justify-content-between">ตั้งค่าข้อมูลส่วนตัว
            </h4>
            <div v-if="!Object.keys(account).length" class="d-flex justify-content-center">
              <div class="spinner-grow" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <div class="col-xl-4 text-center">
                  <img v-if="account" class="mb-3" :src="`data:image/png;base64,${account.image}`" alt="User Image">
                  <img v-else class="mb-3" src="@/assets//user.png" alt="User Image" width="178">
                  <div style="text-align: center; font-family: Prompt; color: rgb(18, 40, 28);">
                    <div style="font-size: 22px; font-weight: 600; margin-bottom: 5px;">{{ account.fullname_th }}</div>
                    <div style="font-size: 20px;">{{ account.fullname_en }}</div>
                    <div style="margin-top: 20px;">
                      <div style="display: inline;">เบอร์โทรศัพท์ : </div>
                      <div style="display: inline;">{{ account.phone }}</div>
                    </div>
                    <div style="margin-top: 5px;">
                      <div style="display: inline;">อีเมล : </div>
                      <div style="display: inline;">{{ account.email }}</div>
                    </div>
                    <div style="margin-top: 5px;">
                      <div style="display: inline;">ตำแหน่ง : </div>
                      <div style="display: inline;">{{ account.job_position }}</div>
                    </div>
                    <div style="margin-top: 5px;">
                      <div style="display: inline;">หน่วยงาน : </div>
                      <div style="display: inline;">
                        <span v-if="account.department">{{ account.department.name }}</span>
                      </div>
                    </div>
                    <div style="height: 20px;"></div>
                  </div>
                </div>
                <div class="col-xl-8">
                  <form @submit.prevent="updateAccount">
                    <div class="row">
                      <div class="mb-3 col-md-6">
                        <label for="" class="form-label">เลขประจำตัวประชาชน</label>
                        <input readonly disabled v-model="account.pid" type="text" class="form-control"
                          placeholder="fullname_th" />
                      </div>
                      <div class="mb-3 col-md-6">
                        <label for="" class="form-label">ชื่อ-นามสกุล</label>
                        <input readonly disabled v-model="account.fullname_th" type="text" class="form-control"
                          placeholder="fullname_th" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="mb-3 col-sm-2 col-md-12 col-lg-2">
                        <label for="" class="form-label">คำนำหน้า</label>
                        <input readonly disabled v-model="account.pname_th" type="text" class="form-control"
                          placeholder="pname_th" />
                      </div>

                      <div class="mb-3 col-sm-5 col-md-6 col-lg-5">
                        <label for="" class="form-label">ชื่อ</label>
                        <input readonly disabled v-model="account.fname_th" type="text" class="form-control"
                          placeholder="fname_th" />
                      </div>

                      <div class="mb-3 col-sm-5 col-md-6 col-lg-5">
                        <label for="" class="form-label">นามสกุล</label>
                        <input readonly disabled v-model="account.lname_th" type="text" class="form-control"
                          placeholder="lname_th" />
                      </div>
                    </div>
                    <div class="mb-3 col-md-12">
                      <label for="" class="form-label">ชื่อ-นามสกุล(อังกฤษ)</label>
                      <input readonly disabled v-model="account.fullname_en" type="text" class="form-control"
                        placeholder="fullname_en" />
                    </div>
                    <div class="row">
                      <div class="mb-3 col-sm-2 col-md-12 col-lg-2">
                        <label for="" class="form-label">Prefix</label>
                        <input readonly disabled v-model="account.pname_en" type="text" class="form-control"
                          placeholder="pname_en" />
                      </div>

                      <div class="mb-3 col-sm-5 col-md-6 col-lg-5">
                        <label for="" class="form-label">First Name</label>
                        <input readonly disabled v-model="account.fname_en" type="text" class="form-control"
                          placeholder="fname_en" />
                      </div>

                      <div class="mb-3 col-sm-5 col-md-6 col-lg-5">
                        <label for="" class="form-label">Last Name</label>
                        <input readonly disabled v-model="account.lname_en" type="text" class="form-control"
                          placeholder="lname_en" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="mb-3 col-md-6 col-xl-2">
                        <label for="" class="form-label">วันเกิด</label>
                        <input readonly disabled v-model="account.birth" type="text" class="form-control"
                          placeholder="birth" />
                      </div>

                      <div class="mb-3 col-md-6 col-xl-2">
                        <label for="" class="form-label">เพศ</label>
                        <input readonly disabled v-model="account.sex" type="text" class="form-control"
                          placeholder="sex" />
                      </div>

                      <div class="mb-3 col-md-12 col-xl-8">
                        <label for="" class="form-label">ที่อยู่</label>
                        <input readonly disabled v-model="account.address" type="text" class="form-control"
                          placeholder="address" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="mb-3 col-lg-3">
                        <label for="" class="form-label">เลขที่</label>
                        <input readonly disabled v-model="account.house_no" type="text" class="form-control"
                          placeholder="เลขที่" />
                      </div>

                      <div class="mb-3 col-lg-3">
                        <label for="" class="form-label">หมู่ที่</label>
                        <input readonly disabled v-model="account.village_no" type="text" class="form-control"
                          placeholder="หมู่ที่" />
                      </div>

                      <div class="mb-3 col-lg-6">
                        <label for="" class="form-label">ตำบล</label>
                        <input readonly disabled v-model="account.sub_district" type="text" class="form-control"
                          placeholder="ตำบล" />
                      </div>

                      <div class="mb-3 col-lg-6">
                        <label for="" class="form-label">อำเภอ</label>
                        <input readonly disabled v-model="account.district" type="text" class="form-control"
                          placeholder="อำเภอ" />
                      </div>

                      <div class="mb-3 col-lg-6">
                        <label for="" class="form-label">จังหวัด</label>
                        <input readonly disabled v-model="account.province" type="text" class="form-control"
                          placeholder="province" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group mb-3 col-md">
                        <label for="">หมายเลขโทรศัพท์</label>
                        <input v-model="account.phone" type="text" class="form-control" name="" id="" placeholder="">
                      </div>
                      <div class="form-group mb-3 col-md">
                        <label for="">Email</label>
                        <input v-model="account.email" type="email" class="form-control" name="" id="" placeholder="">
                      </div>
                    </div>
                    <div class="tile-footer d-flex justify-content-between">
                      <button type="submit" class="btn btn-warning">
                        <i class="bi bi-floppy"></i> บันทีกข้อมูล
                      </button>
                    </div>
                  </form>
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="user-password">
          <div class="tile user-settings">
            <h4 class="line-head">ตั้งค่ารหัสผ่าน</h4>
            <form @submit.prevent="submitPassword" novalidate>
              <div class="row">
                <div class="col-md-12 mb-3">
                  <label>รหัสผ่านใหม่</label>
                  <input v-model="data.password" class="form-control" type="text">
                  <div v-if="v$.data.password.$error" class="text-danger">
                    This is a required field.
                    <span v-if="v$.data.password.$error && v$.data.password.minLength">
                      รหัสผ่านต้องมีอักขระอย่างน้อย 6 ตัว
                    </span>
                  </div>
                </div>
                <div class="clearfix"></div>
                <div class="col-md-12 mb-3">
                  <label>ยืนยันรหัสผ่านใหม่</label>
                  <input v-model="data.password_confirmation" class="form-control" type="text">
                  <div v-if="v$.data.password_confirmation.$error" class="text-danger">
                    This is a required field.
                    <span v-if="v$.data.password_confirmation.sameAsPassword">รหัสผ่านไม่ตรงกัน</span>
                  </div>
                </div>
              </div>
              <div class="row mb-10">
                <div class="col-md-12">
                  <button class="btn btn-warning" type="submit" :disabled="v$.data.password_confirmation.$error">
                    <i class="bi bi-floppy"></i> เปลี่ยนรหัสผ่าน</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, sameAs } from '@vuelidate/validators'

import { mapState } from 'vuex';
import accountsService from '@/services/accounts-service';

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      account: {},
      data: {
        password: '',
        password_confirmation: '',
      }
    }
  },
  validations() {
    return {
      data: {
        password: { required, minLength: minLength(6) },
        password_confirmation: { required, sameAsPassword: sameAs(this.data.password) }
      }
    }
  },
  methods: {
    async updateAccount() {
      await accountsService.update(this.account.id, this.account);
      await this.showUpdate()
      await this.getUser();
    },
    async getUser() {
      const res = await accountsService.get(this.user.account_id)
      this.account = res.data
    },
  },
  computed: {
    isDisabled() {
      return this.v$.$invalid
    },
    ...mapState(['user'])
  },
  created() {
    this.getUser()
  },
}
</script>

<style>
.user .profile .info img {
  border-radius: 0%;
}

.user .profile .cover-image {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  background-image: url(@/assets/bg.jpg);
  background-size: cover;
  background-position: center;
  min-height: 300px;
  opacity: 1;
}
</style>